import { teamCard } from './teamCard.mock';
import { statistics } from './statistics.mock';
import { lineups } from './lineups.mock';
import { matchesTeams } from './matchesTeams.mock';
import { classification } from './classification.mock';
import { rankings } from './rankings.mock';

export const teamStatisticsMock = {
  teamView: 'all',
  teamCard,
  statistics,
  lineups,
  matchesTeams,
  classification,
  rankings,
};

export const teamStatisticsByTeamId = {
  ...teamStatisticsMock,
};
